/**
 * Strips a trailing unclosed HTML tag from a streaming markdown string.
 *
 * Streaming tokens can split mid-tag (e.g. `"...text <spa"`). Feeding that to
 * `rehype-raw` produces DOM shapes that differ from the next tick's output,
 * which can trip React reconciliation and throw `removeChild` errors.
 * Returning a string that ends at the last complete tag avoids the mismatch.
 */
export function removeTrailingPartialTag(value: string): string {
  const lastOpen = value.lastIndexOf("<")
  const lastClose = value.lastIndexOf(">")

  if (lastOpen === -1 || lastOpen < lastClose) {
    return value
  }

  const tail = value.slice(lastOpen)

  if (/^<[A-Za-z][^>]*$/.test(tail)) {
    return value.slice(0, lastOpen)
  }

  return value
}
